import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'matchingSearchText'
})
export class MatchingSearchTextPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (args && value && Array.isArray(value)) {
      let _search = args.toString().toLowerCase();
      return value.filter(item => {
        return this.matchesDisplay(item, _search);
      });
    } else {
      return value;
    }
  }

  matchesDisplay(item: any, _search: string): boolean {
    let found = false;

    if (item) {
      // HACK to allow searching for event types as well
      let text = item.display || item.description || (item.name + item.roomName + item.floorName);
      if (text) {
        let _display = text.toLowerCase();
        found = (_display.indexOf(_search) >= 0);
        if (!found && item.codeItems) {
          for (let i = 0; i < item.codeItems.length; i++) {
            let ci = item.codeItems[i];
            found = this.matchesDisplay(ci, _search);
            if (found) break;
          }
        }
      }
    }

    return found;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/matching-search-text.pipe.ts